import { PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IDeal } from "src/@types/deals";
import { getDealsAsync } from "./actions";
import { DealsState } from "./slice";

type ActionReducerMapBuilderWithDealsState =
  ActionReducerMapBuilder<DealsState>;

export const getDealsReducer = (
  builder: ActionReducerMapBuilderWithDealsState,
) => {
  builder.addCase(getDealsAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(getDealsAsync.fulfilled,
    (state, action: PayloadAction<IResponseWithPagination<IDeal>>) => {
      state.isLoading = false;
      state.data = action.payload;
    }
  );

  builder.addCase(getDealsAsync.rejected, (state) => {
    state.isLoading = false;
    state.data = null;
  }
  );
}
